module.exports = __webpack_public_path__ + "img/shiyongbangzhu.129a2ea1.png";